if(window.__mtCargado){throw new Error('mt-scripts ya cargado');}window.__mtCargado=true;
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      var principal = root.querySelector('.mt-galeria__principal');
      var minis = root.querySelectorAll('[data-mini]');
      function mostrar(src, srcset, id) {
        if (!principal) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.setAttribute('aria-current', m.dataset.mediaId === String(id) ? 'true' : 'false'); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.srcset, m.dataset.mediaId); });
      });

      var datos = root.querySelector('[data-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = root.querySelector('[data-boton]');
      var precio = root.querySelector('[data-precio]');
      var tachado = root.querySelector('[data-tachado]');
      var ahorro = root.querySelector('[data-ahorro]');
      var fmt = root.dataset.moneda || '{{amount_with_comma_separator}} €';

      function dinero(c) {
        var v = (c / 100).toFixed(2);
        var coma = v.replace('.', ',');
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount\s*\}\}/, v)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(c / 100));
      }

      function actualizar() {
        var elegidas = [];
        root.querySelectorAll('[data-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
          var etiqueta = fs.querySelector('[data-valor-elegido]');
          if (etiqueta && c) etiqueta.textContent = c.value;
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.dataset.noDisponible; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false;
            if (ahorro) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { tachado.hidden = true; if (ahorro) ahorro.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
        }
        if (v.featured_media) {
          var mini = root.querySelector('[data-mini][data-media-id="' + v.featured_media.id + '"]');
          if (mini) mostrar(mini.dataset.src, mini.dataset.srcset, mini.dataset.mediaId);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      root.querySelectorAll('[data-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = root.querySelector('[data-cantidad]');
      if (cant) {
        var inp = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(inp.value, 10) || 1;
            n = b.dataset.paso === 'mas' ? n + 1 : Math.max(1, n - 1);
            inp.value = n;
          });
        });
      }
    });
  }

  function init() { initReveal(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
(function(){function f(r){var c=null;r.querySelectorAll('[data-opcion] input:checked').forEach(function(i){var v=i.value.toLowerCase();if(v.indexOf('verdoso')>-1)c='cap';else if(v.indexOf('gris')>-1)c='gris';});if(!c)return;var first=null,ok=false;r.querySelectorAll('[data-mini]').forEach(function(m){var cap=(m.dataset.src||'').toLowerCase().indexOf('verdoso')>-1;var show=(c==='cap')===cap;m.style.display=show?'':'none';if(show&&!first)first=m;if(show&&m.getAttribute('aria-current')==='true')ok=true;});if(first&&!ok)first.click();}function go(){document.querySelectorAll('[data-mt-producto]').forEach(function(r){if(r.dataset.mtColor)return;r.dataset.mtColor='1';r.querySelectorAll('[data-opcion] input').forEach(function(i){i.addEventListener('change',function(){setTimeout(function(){f(r);},0);});});f(r);});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();document.addEventListener('shopify:section:load',go);})();
(function(){function h(){document.querySelectorAll('[data-opcion] input').forEach(function(i){if(/120x180/i.test(i.value)){i.disabled=true;i.style.display='none';var l=i.id?document.querySelector('label[for="'+i.id+'"]'):null;if(l)l.style.display='none';var p=i.closest('label');if(p)p.style.display='none';}});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',h);else h();document.addEventListener('shopify:section:load',h);})();
(function(){function m(){document.querySelectorAll('[data-cantidad] input,input[name="quantity"],input[name="updates[]"]').forEach(function(i){i.max=1;if(+i.value>1){i.value=1;i.dispatchEvent(new Event('change',{bubbles:true}));}});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',m);else m();document.addEventListener('change',function(){setTimeout(m,30);});document.addEventListener('click',function(){setTimeout(m,300);});})();
(function(){function g(){if(/[?&]variant=/.test(location.search))return;var r=document.querySelector('[data-mt-producto]');if(!r)return;var ms=r.querySelectorAll('[data-mini]');for(var k=0;k<ms.length;k++){if(ms[k].style.display!=='none'){ms[k].click();break;}}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(g,60);});else setTimeout(g,60);})();